document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('#gustav-focus-section');
  if (!section) return;

  const desktopGustav = section.querySelector('#gustavCharacterDesktop');
  const mobileGustav = section.querySelector('#gustavCharacterMobile');
  const blocks = section.querySelectorAll('.gustav-focus__block');

  if (!blocks.length) return;

  const isMobile = window.matchMedia('(max-width: 989px)');

  function setActiveBlock(activeBlock) {
    if (!activeBlock) return;

    const targetClass = activeBlock.dataset.gustav;

    blocks.forEach(function (block) {
      block.classList.remove('is-active');
    });

    activeBlock.classList.add('is-active');

    if (desktopGustav && targetClass) {
      desktopGustav.classList.remove('point-1', 'point-2', 'point-3');
      desktopGustav.classList.add(targetClass);
    }
  }

  function getMostVisibleBlock() {
    let bestBlock = null;
    let bestScore = -1;

    blocks.forEach(function (block) {
      const rect = block.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      const visibleTop = Math.max(rect.top, 0);
      const visibleBottom = Math.min(rect.bottom, viewportHeight);
      const visibleHeight = Math.max(0, visibleBottom - visibleTop);
      const ratio = visibleHeight / Math.max(rect.height, 1);

      if (ratio > bestScore) {
        bestScore = ratio;
        bestBlock = block;
      }
    });

    return bestBlock;
  }

  function getClosestBlockToCenter() {
    let bestBlock = null;
    let bestDistance = Infinity;
    const viewportCenter = window.innerHeight / 2;

    blocks.forEach(function (block) {
      const rect = block.getBoundingClientRect();
      const blockCenter = rect.top + rect.height / 2;
      const distance = Math.abs(blockCenter - viewportCenter);

      if (distance < bestDistance) {
        bestDistance = distance;
        bestBlock = block;
      }
    });

    return bestBlock;
  }

  function updateLeavingState() {
    const rect = section.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const leavingThreshold = viewportHeight * 0.22;
    const isLeaving = rect.bottom < viewportHeight + leavingThreshold && rect.bottom > 0;

    section.classList.toggle('is-leaving', isLeaving);
  }

  function updateDesktop() {
    if (isMobile.matches) return;

    const activeBlock = getMostVisibleBlock();
    setActiveBlock(activeBlock);
    updateLeavingState();
  }

  function updateMobile() {
    if (!isMobile.matches) return;

    const activeBlock = getClosestBlockToCenter();
    setActiveBlock(activeBlock);

    if (!mobileGustav) return;

    const rect = section.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const visible = rect.top < viewportHeight * 0.82 && rect.bottom > viewportHeight * 0.2;

    mobileGustav.classList.toggle('is-visible', visible);
  }

  function handleScroll() {
    updateDesktop();
    updateMobile();
  }

  function handleResize() {
    handleScroll();
  }

  handleScroll();

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', handleResize);
});

document.addEventListener('DOMContentLoaded', function () {
  const herkunftSection = document.querySelector('#herkunft-gustav-section');
  if (!herkunftSection) return;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        herkunftSection.classList.toggle('is-visible', entry.isIntersecting);
      });
    },
    {
      threshold: 0.2
    }
  );

  observer.observe(herkunftSection);
});